import React, { useMemo } from 'react';
import NumArrow from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/NumArrow';
import RingRatioBubble from '@/pages/opinion/components/Snippets/RingRatioBubble';
import { financeFormat } from '@/pages/home/utils/common';
import moment from 'moment';
// overview卡片环比内容新组件
const CardRateContent = (props: any) => {
  const {
    numArrowData,
    cardItem = {},
    isShowRateTips = false,
    dateType,
    metricTitleLocaleText = '',
  } = props;
  const {
    endRateDateTime,
    endRateEndTime,
    endRateStartTime,
    endRateValue,
    endTwoRateDateTime,
    endTwoRateEndTime,
    endTwoRateStartTime,
    endTwoRateValue,
  } = cardItem;
  const newTimeCur = useMemo(() => {
    switch (dateType) {
      case 'week':
        return [endRateStartTime, endRateEndTime];
      case 'month':
        return [endRateDateTime ? moment(endRateDateTime)?.format('YYYY-MM') : '-'];
      default:
        return [endRateDateTime];
    }
  }, [dateType, endRateStartTime, endRateEndTime, endRateDateTime]);
  const oldTimeCur = useMemo(() => {
    switch (dateType) {
      case 'week':
        return [endTwoRateStartTime, endTwoRateEndTime];
      case 'month':
        return [endTwoRateDateTime ? moment(endTwoRateDateTime)?.format('YYYY-MM') : '-'];
      default:
        return [endTwoRateDateTime];
    }
  }, [dateType, endTwoRateStartTime, endTwoRateEndTime, endTwoRateDateTime]);
  return (
    <>
      {isShowRateTips ? (
        <RingRatioBubble
          otherInfo={<div className="item-title">{metricTitleLocaleText}</div>}
          newTime={newTimeCur}
          oldTime={oldTimeCur}
          oldValue={financeFormat(endTwoRateValue, 2, false, '-')}
          newValue={financeFormat(endRateValue, 2, false, '-')}
          placement="top-start"
        >
          <NumArrow dataContent={numArrowData} type={'num'}>
            {' '}
          </NumArrow>
        </RingRatioBubble>
      ) : (
        <NumArrow dataContent={numArrowData} type={'num'}>
          {' '}
        </NumArrow>
      )}
    </>
  );
};
export default CardRateContent;
